module.exports = __webpack_public_path__ + "static/media/gts01.9449d362.png";